import { Configuration } from '@liks/lac-svc-api/esm/runtime';
import { getKeycloak } from '../auth/keycloak';
import { resolveBackendBaseUrl } from '../utils/backendBaseUrl';

async function getAuthorizationHeader(): Promise<string> {
  const keycloak = getKeycloak();

  if (!keycloak.authenticated) {
    throw new Error(
      'Cannot call the LAC service without an authenticated user',
    );
  }

  await keycloak.updateToken(30);

  if (!keycloak.token) {
    throw new Error('Keycloak did not provide an access token');
  }

  return `Bearer ${keycloak.token}`;
}

export const lacApiConfiguration = new Configuration({
  basePath: resolveBackendBaseUrl(),
  accessToken: getAuthorizationHeader,
});
